var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_489_5273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3599 34C49.3599 42.4831 42.483 49.36 33.9999 49.36C25.5168 49.36 18.6399 42.4831 18.6399 34C18.6399 25.5169 25.5168 18.64 33.9999 18.64C42.483 18.64 49.3599 25.5169 49.3599 34Z",
    fill: "url(#paint0_radial_489_5273)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 19.28C25.8704 19.28 19.28 25.8704 19.28 34C19.28 42.1296 25.8704 48.72 34 48.72C42.1296 48.72 48.72 42.1296 48.72 34C48.72 25.8704 42.1296 19.28 34 19.28ZM18 34C18 25.1634 25.1634 18 34 18C42.8366 18 50 25.1634 50 34C50 42.8366 42.8366 50 34 50C25.1634 50 18 42.8366 18 34Z",
    fill: "#BDBDFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_489_5273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 31.8556L34 26.8L27.5 31.8556V39.8001C27.5 40.1832 27.6522 40.5506 27.9231 40.8214C28.1939 41.0923 28.5613 41.2445 28.9444 41.2445H39.0556C39.4386 41.2445 39.806 41.0923 40.0769 40.8214C40.3478 40.5506 40.5 40.1832 40.5 39.8001V31.8556Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 41.2444V34.0222H31.8334V41.2444",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_489_5273",
    x: 0.639893,
    y: 0.640015,
    width: 66.72,
    height: 66.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_489_5273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_489_5273",
    x: 22.75,
    y: 26.05,
    width: 22.5,
    height: 23.9445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.741176 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_489_5273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_489_5273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_489_5273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9999 34) rotate(90) scale(15.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6429CD",
    stopOpacity: 0.29
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActiveIcon);
export default __webpack_public_path__ + "static/media/homeActiveIcon.c3249a0667a0e77f7ceb52dc906a940e.svg";
export { ForwardRef as ReactComponent };